module.exports = __webpack_public_path__ + "static/media/game2.e1f44667.jpg";